import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (24.757 / 24);
  const localHeight = size * (23 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 24.757 23">
      <g transform="translate(-3520 -7063)">
        <path
          d="M260.506,1481.588a.807.807,0,0,1,1.141-1.141,9.886,9.886,0,1,0-2.836-8.075h1.772l-2.607,3.209-2.6-3.209h1.808a11.5,11.5,0,1,1,3.318,9.216Zm7.994-6.75a.807.807,0,0,1-.807-.807v-6.753a.807.807,0,0,1,1.614,0v5.947h4.4a.807.807,0,1,1,0,1.614Z"
          transform="translate(3264.62 5601.044)"
          fill={localColor}
        />
      </g>
    </svg>
  );
};

export default Index;
